export const greys = {
  white: "#FFFFFF",
  grey03: "#F4F4F7",
  grey12: "#D7D6DA",
  grey20: "#C7C7CC",
  grey50: "#777680",
  black: "#000000"
} as const

export const primary = {
  primary1_600: "#007AD2",
  primary1: "#0496FF",
  primary1_200: "#81CAFF",
  primary1_100: "#B3DFFF",
  primary1_50: "#DAEFFF",
  primary2: "#21295C",
  primary2_200: "#9094AD",
  primary2_100: "#BCBECE",
  primary2_50: "#DEDFE7"
} as const

export const secondary = {
  secondary1: "#3DCCC7",
  secondary1_200: "#9EE5E3",
  secondary1_100: "#C4EFEE",
  secondary1_50: "#E2F8F7",
  secondary2: "#028090",
  secondary2_200: "#80BFC7",
  secondary2_100: "#B3D8DD",
  secondary2_50: "#D9ECEF"
} as const

export const tertiary = {
  g_600: "#15837F",
  g_400: "#00BD9D",
  g_200: "#73D3C4",
  b_400: "#1F59D5",
  b_300: "#5787F5",
  b_200: "#88A7E5",
  b_50: "#D4E1F6",
  r_400: "#DE3434",
  r_200: "#E89495",
  y_400: "#F9BC14",
  y_200: "#F6D885",
  o_400: "#F97814",
  o_200: "#F6B685",
  o_50: "#FEF8F3",
  p_400: "#FF4270",
  p_200: "#F99BB3",
  v_400: "#41AECF",
  v_200: "#8FCEE0",
  j_400: "#52489C",
  j_200: "#AAA6CE",
  i_400: "#8352E1",
  i_200: "#BBA3EC",
  i_50: "#E8E1F6",
  f_400: "#C140AF",
  f_200: "#D99AD2",
  f_50: "#F5E6F4",
  s2_50: "#D9ECEF",
  s2_400: "#028090"
} as const

export const utility = {
  white: greys.white,
  ink: greys.black,
  subdued: greys.grey20,
  contrast: greys.black,
  highlight: greys.grey03,
  promo: "#BDF168",
  success: "#4CAF50",
  bgSuccess: "#DBEFDC",
  warning: "#D49900",
  bgWarning: "#FFF2CD",
  error: "#B30000",
  bgError: "#F8D7D9",
  bgInfo: "#CEF4FC",
  gold: "#E3AE5D",
  silver: "#CAC7C3",
  bronze: "#AE956F"
} as const

export const products = {
  medical: "#1EBCB2",
  perks: primary.primary1,
  recognition: "#EE6352",
  wellness: "#8352E1",
  rewards: "#E4A700"
} as const
